import type { ReactElement } from 'react';
import styled from '@emotion/styled';

import { tokens } from '@hotjar/hotsauce';

interface Props {
  icon?: ReactElement;
  title?: ReactElement | string;
  subtitle?: ReactElement | string;
  cta?: ReactElement;
}

const Container = styled.div`
  align-items: center;
  background: ${tokens.color.neutral_100};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: ${tokens.spacer.x2} ${tokens.spacer.x3};
`;

const IconContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-right: ${tokens.spacer.x2};
`;

const ContentContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  justify-content: space-between;
`;

const Title = styled.span`
  ${tokens.text('subtitle2')};

  display: block;
`;

const Subtitle = styled.span`
  ${tokens.text('body2')};

  display: block;
`;

export const BillingAlert = ({ icon, title, subtitle, cta }: Props): JSX.Element => {
  return (
    <Container>
      {icon && <IconContainer>{icon}</IconContainer>}
      <ContentContainer>
        <div>
          {title && <Title>{title}</Title>}
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </div>
        {cta ?? null}
      </ContentContainer>
    </Container>
  );
};
